import React from "react"
import ButtonSign from "../components/button-sign"
const close = require("../images/icons/dp-close-white.svg")

export default function VideoOverlay({ item, toggleShow, show }) {
  return (
    <div
      className={`c-video-overlay ${
        show ? "c-video-overlay--show" : "c-video-overlay--hide"
      }`}
    >
      <button
        className="c-video-overlay__close c-button c-button--close"
        onClick={toggleShow}
      >
        <span className="c-button__text">Stäng</span>
        <img className="c-button__img" src={close} />
      </button>
      <div className="c-video-overlay__content">
        <div className="row c-video-overlay__caption">
          <div className="col-xs-12 col-md-7">
            {item.title.substring(0, item.title.length - 8)}
          </div>
          <div className="col-xs-12 col-md-5"></div>
        </div>
        <div className="c-video-overlay__image col-md-12">
          <img src={item.image} />
        </div>
      </div>
    </div>
  )
}
